var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoreHorizontal = function SvgMoreHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 11.667A2.34 2.34 0 0 0 4.667 14 2.34 2.34 0 0 0 7 16.333 2.34 2.34 0 0 0 9.333 14 2.34 2.34 0 0 0 7 11.667m14 0A2.34 2.34 0 0 0 18.667 14 2.34 2.34 0 0 0 21 16.333 2.34 2.34 0 0 0 23.333 14 2.34 2.34 0 0 0 21 11.667m-7 0A2.34 2.34 0 0 0 11.667 14 2.34 2.34 0 0 0 14 16.333 2.34 2.34 0 0 0 16.333 14 2.34 2.34 0 0 0 14 11.667"
  })));
};
export default SvgMoreHorizontal;